if (!customElements.get('campaign-favorites')) {
  customElements.define('campaign-favorites', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.cards = [...this.track.children];
      this.controls = this.querySelector('[data-controls]');
      this.mobile = matchMedia('(max-width: 767px)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.mobile.addEventListener('change', () => this.sync(), options);
      // The theme loads Swiper with defer near the end of the document.
      document.addEventListener('DOMContentLoaded', () => this.sync(), options);
      this.sync();
    }
    sync() {
      if (!this.mobile.matches) {
        this.swiper?.destroy(true, true);
        this.swiper = null;
        this.viewport.classList.remove('swiper');
        this.track.classList.remove('swiper-wrapper');
        this.cards.forEach(card => card.classList.remove('swiper-slide'));
        this.controls.hidden = true;
        return;
      }
      if (this.swiper || !window.Swiper) return;
      this.viewport.classList.add('swiper');
      this.track.classList.add('swiper-wrapper');
      this.cards.forEach(card => card.classList.add('swiper-slide'));
      const update = swiper => {
        this.querySelector('[data-counter]').textContent = `${String(swiper.activeIndex + 1).padStart(2, '0')} / ${String(this.cards.length).padStart(2, '0')}`;
        this.querySelector('[data-progress]').value = swiper.activeIndex + 1;
      };
      this.swiper = new Swiper(this.viewport, {
        slidesPerView: 'auto', spaceBetween: 16, loop: false,
        speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300,
        navigation: { prevEl: this.querySelector('[data-prev]'), nextEl: this.querySelector('[data-next]') },
        a11y: { prevSlideMessage: 'Vorheriges Geschenk', nextSlideMessage: 'Nächstes Geschenk' },
        on: { init: update, slideChange: update }
      });
      this.controls.hidden = this.cards.length < 2;
    }
    disconnectedCallback() { this.swiper?.destroy(true, true); this.swiper = null; this.abort?.abort(); }
  });
}
